<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CWCqQO/tc-custom/9781567925432.jpg?1728353110090" alt="This image is the cover for the book Missing Person, Verba Mundi International Literature Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Missing Person, Verba Mundi International Literature Series
      </h1>
      <p class="bookDescription body article font2">
        <b>An amnesiac searches for his identity, from Polynesia to Rome, in this novel by the Nobel Prize–winning author of <i>Dora Bruder</i>.</b><br/><br/>Guy Roland is in pursuit of the identity he lost in the murky days of the Paris Occupation. For ten years, he has lived without a past. His current life and name were given to him by his recently retired boss, Hutte, who welcomed him, a onetime client, into his detective agency. Guy makes full use of Hutte’s files—directories, yearbooks, and papers of all kinds going back half a century—but his leads are few. Could he really be the person in that photograph, a young man remembered by some as a South American attaché? Or was he someone else, perhaps the disappeared scion of a prominent local family? He interviews strangers and is tantalized by half-clues until, at last, he grasps a thread that leads him through the maze of his own repressed experience.<br/><br/>Published in France as <i>Rue des Boutiques obscures</i>, this is both a detective mystery and a haunting meditation on the nature of the self, Patrick Modiano’s spare, hypnotic prose, superbly translated by Daniel Weissbort, draws readers into the intoxication of a rare literary experience.<br/><br/><b>Praise for <i>Missing Persons</i></b><br/><br/><b>“[An] elliptical, engrossing rumination on the essence of identity and the search for self.” —Frank Sennet, <i>Booklist</i></b><br/><br/><b>“A fine introduction to his work. . . . Beautifully written and perfectly noirish, as though the world were being seen through a haze of Gauloise smoke. Be warned, though: after reading this, a sensitive soul may well seize up the next time a stranger waves.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Modiano, Daniel Weissbort
      </h2>
      
      <p class="authorDescription body article"><P><B>Patrick Modiano</B> was awarded the 2014 Nobel Prize in Literature for a body of work that includes <B><I>Missing Person</B></I> and <B><I>Honeymoon</B></I> (both published by Godine).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David R. Godine, Publisher
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50ffb857